import {
  Home, Sparkles, Search, Ticket, Map, Package, Receipt, CreditCard, FileText,
  Users, Grid3x3, MessageCircle, Mail, Bell, BarChart3, Gift, LifeBuoy, User,
  Plane, Hotel, Train, Bus, Car, Compass, Building2, Handshake, Image, Settings,
  LayoutDashboard, Server, BadgePercent, ScrollText, Wallet, Crown, MailWarning, ShoppingBag, ShoppingCart, Store, ShieldCheck, MapPin, Truck, Eye, Star, Heart, RotateCcw, Boxes, Percent, ShieldAlert, Wand2, Radio, Megaphone, Globe, CalendarClock, QrCode, Flag, Ship,
} from "lucide-react";

export const CUSTOMER_NAV = [
  { to: "/app/home", label: "Dashboard", icon: Home, section: "Account" },
  { to: "/services?travel_type=flight", label: "Flights", icon: Plane, section: "Travel" },
  { to: "/services?travel_type=train", label: "Trains", icon: Train, section: "Travel" },
  { to: "/services?travel_type=package", label: "Holiday Packages", icon: Package, section: "Travel" },
  { to: "/cruises", label: "Cruises", icon: Ship, section: "Travel" },
  { to: "/app/shop-orders", label: "My Orders", icon: ShoppingBag, section: "Account" },
  { to: "/app/cruises", label: "My Cruises", icon: Ship, section: "Account" },
  { to: "/app/custom-orders", label: "Custom Orders", icon: Wand2, section: "Account" },
  { to: "/app/returns", label: "Returns & Refunds", icon: RotateCcw, section: "Account" },
  { to: "/app/payments", label: "Payments", icon: Wallet, section: "Account" },
  { to: "/app/invoices", label: "Invoices", icon: Receipt, section: "Account" },
  { to: "/app/reviews", label: "Reviews & Ratings", icon: Star, section: "Account" },
  { to: "/app/documents", label: "My Documents", icon: FileText, section: "More" },
  { to: "/app/reminders", label: "Reminders", icon: Bell, section: "More" },
  { to: "/app/notifications", label: "Notifications", icon: Bell, section: "Updates" },
  { to: "/app/support", label: "Help & Support", icon: LifeBuoy, section: "Account" },
  { to: "/app/profile", label: "Account Settings", icon: User, section: "Account" },
  { to: "/app/search", label: "Search", icon: Search, section: "Shopping", hidden: true },
  { to: "/app/subscriptions", label: "My Subscriptions", icon: CreditCard, section: "Money", hidden: true },
  { to: "/app/whatsapp", label: "WhatsApp", icon: MessageCircle, section: "More", hidden: true },
  { to: "/app/reports", label: "Reports", icon: BarChart3, section: "More", hidden: true },
  { to: "/app/subscription", label: "My Subscription", icon: CreditCard, section: "Account", hidden: true },
  { to: "/app/rewards", label: "Offers & Rewards", icon: Gift, section: "Account", hidden: true },
];

export const CUSTOMER_BOTTOM = [
  { to: "/app/home", label: "Home", icon: Home },
  { to: "/app/shop", label: "Shop", icon: ShoppingBag },
  { to: "/services", label: "Services", icon: CalendarClock },
  { to: "/app/cart", label: "Cart", icon: ShoppingCart },
  { to: "/app/ai", label: "AI Secretary", icon: Sparkles },
];

export const AGENT_NAV = [
  { to: "/seller/home", label: "Dashboard", icon: Home },
  { to: "/seller/analytics", label: "Business Analytics", icon: BarChart3 },
  { to: "/seller/ai", label: "Seller AI Assistant", icon: Sparkles },
  { to: "/seller/verification", label: "Compliance", icon: ShieldCheck },
  { to: "/seller/selling-areas", label: "Selling Areas", icon: MapPin },
  { to: "/seller/storefront", label: "Storefront", icon: Store },
  { to: "/seller/promote", label: "Promote / QR", icon: QrCode },
  { to: "/seller/storefront-preview", label: "Store Preview", icon: Eye },
  { to: "/seller/products", label: "Products", icon: ShoppingBag },
  { to: "/seller/services", label: "Services", icon: Sparkles },
  { to: "/seller/services?travel=1", label: "Travel & Holidays", icon: Plane },
  { to: "/seller/cruises", label: "Cruises", icon: Ship },
  { to: "/seller/fleet", label: "Vehicles & Drivers", icon: Car },
  { to: "/seller/bookings", label: "Bookings", icon: CalendarClock },
  { to: "/seller/inventory", label: "Inventory", icon: Boxes },
  { to: "/seller/customers", label: "Customers", icon: Users },
  { to: "/seller/commission", label: "Commission", icon: Percent },
  { to: "/seller/service-commission", label: "Service Commission", icon: Percent },
  { to: "/seller/orders", label: "Orders", icon: Package, badgeKey: "seller_requests" },
  { to: "/seller/custom-requests", label: "Custom Requests", icon: Wand2 },
  { to: "/seller/reviews", label: "Reviews", icon: Star },
  { to: "/seller/shipping", label: "Shipping", icon: Truck },
  { to: "/seller/settlements", label: "Settlements", icon: Wallet },
  { to: "/seller/invoices", label: "Invoices", icon: Receipt },
  { to: "/seller/credit", label: "Credit", icon: CreditCard },
  { to: "/seller/promotions", label: "Promotions", icon: BadgePercent },
  { to: "/seller/poster", label: "AI Poster Maker", icon: Image },
  { to: "/seller/whatsapp", label: "WhatsApp", icon: MessageCircle },
  { to: "/seller/messages", label: "Message Center", icon: Mail },
  { to: "/seller/support", label: "Seller Support", icon: LifeBuoy },
  { to: "/seller/documents", label: "Documents", icon: FileText },
  { to: "/seller/team", label: "Team & Branches", icon: Users },
  { to: "/seller/reports", label: "Reports", icon: BarChart3 },
  { to: "/seller/whatsapp-plans", label: "Bulk WhatsApp", icon: MessageCircle },
];

export const AGENT_BOTTOM = [
  { to: "/seller/home", label: "Home", icon: Home },
  { to: "/seller/products", label: "Products", icon: ShoppingBag },
  { to: "/seller/orders", label: "Orders", icon: Package, badgeKey: "seller_requests" },
  { to: "/seller/custom-requests", label: "Custom Requests", icon: Wand2 },
  { to: "/seller/ai", label: "AI", icon: Sparkles },
  { to: "/seller/whatsapp", label: "WhatsApp", icon: MessageCircle },
];

export const ADMIN_NAV = [
  { to: "/admin/control-center", label: "Platform Control Center", icon: Settings, section: "Overview" },
  { to: "/admin/control-center#feature-flags", label: "Settings & Feature Flags", icon: Flag, section: "Overview" },
  { to: "/admin/dashboard", label: "Control Center", icon: LayoutDashboard, section: "Overview" },
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true, section: "Overview" },
  { to: "/admin/customers", label: "Customers", icon: Users, section: "Overview" },

  { to: "/admin/marketplace", label: "Marketplace", icon: Store, section: "Catalog" },
  { to: "/admin/products", label: "Products", icon: ShoppingBag, section: "Catalog" },
  { to: "/admin/services", label: "Services", icon: Sparkles, section: "Catalog" },
  { to: "/admin/travel-listings", label: "Travel & Holidays", icon: Plane, section: "Catalog" },
  { to: "/admin/cruises", label: "Cruises", icon: Ship, section: "Catalog" },
  { to: "/admin/product-feeds", label: "Product Feeds", icon: Boxes, section: "Catalog" },
  { to: "/admin/fleet", label: "Vehicles & Drivers", icon: Car, section: "Catalog" },
  { to: "/admin/holiday-banner", label: "Holiday Banner", icon: Image, section: "Catalog" },
  { to: "/admin/catalog", label: "Product Configuration", icon: Grid3x3, section: "Catalog" },
  { to: "/admin/variant-requests", label: "Variant Requests", icon: Grid3x3, section: "Catalog" },
  { to: "/admin/inventory", label: "Inventory", icon: Boxes, section: "Catalog" },
  { to: "/admin/storefronts", label: "Seller Storefronts", icon: Store, section: "Catalog" },

  { to: "/admin/search", label: "Search Management", icon: Search, section: "Discovery" },
  { to: "/admin/recommendations", label: "Recommendations", icon: Sparkles, section: "Discovery" },
  { to: "/admin/sponsored", label: "Sponsored Slots", icon: BadgePercent, section: "Discovery" },
  { to: "/admin/home-cms", label: "Homepage", icon: Home, section: "Discovery" },
  { to: "/admin/reviews", label: "Reviews & Ratings", icon: Star, section: "Discovery" },

  { to: "/admin/orders", label: "Orders", icon: Package, section: "Orders & Fulfilment" },
  { to: "/admin/shipping", label: "Shipping", icon: Truck, section: "Orders & Fulfilment" },
  { to: "/admin/direct-ship", label: "Ship Directly", icon: Truck, section: "Orders & Fulfilment" },
  { to: "/admin/checkout", label: "Checkout Health", icon: CreditCard, section: "Orders & Fulfilment" },
  { to: "/admin/refunds", label: "Refunds", icon: Receipt, section: "Orders & Fulfilment" },

  { to: "/admin/seller-verification", label: "Seller Verification", icon: ShieldCheck, section: "Trust & Safety" },
  { to: "/admin/verified-agents", label: "Verified Agents", icon: ShieldCheck, section: "Trust & Safety" },
  { to: "/admin/moderation", label: "Moderation", icon: ShieldAlert, section: "Trust & Safety" },
  { to: "/admin/risk", label: "Risk & Fraud", icon: ShieldAlert, section: "Trust & Safety" },

  { to: "/admin/finance", label: "Financial Overview", icon: Receipt, section: "Finance" },
  { to: "/admin/payouts-report", label: "Payouts Report", icon: Wallet, section: "Finance" },
  { to: "/admin/invoices", label: "Invoices", icon: Receipt, section: "Finance" },
  { to: "/admin/settlements", label: "Settlements", icon: Wallet, section: "Finance" },
  { to: "/admin/commission", label: "Commission", icon: BadgePercent, section: "Finance" },
  { to: "/admin/service-commission", label: "Service Commission", icon: BadgePercent, section: "Finance" },
  { to: "/admin/promotions", label: "Promotions", icon: BadgePercent, section: "Finance" },
  { to: "/admin/analytics", label: "Marketplace Analytics", icon: BarChart3, section: "Finance" },

  { to: "/admin/subscriptions", label: "Subscription Plans", icon: CreditCard, section: "Billing" },
  { to: "/admin/coupons", label: "Coupons", icon: BadgePercent, section: "Billing" },
  { to: "/admin/whatsapp-plans", label: "Bulk WhatsApp Plans", icon: MessageCircle, section: "Billing" },

  { to: "/admin/campaigns", label: "Email Campaigns", icon: Megaphone, section: "Growth" },
  { to: "/admin/chatbot-training", label: "Chatbot Training", icon: Sparkles, section: "Growth" },
  { to: "/admin/whatsapp-center", label: "WhatsApp Center", icon: MessageCircle, section: "Growth" },
  { to: "/admin/seo", label: "SEO Manager", icon: Globe, section: "Growth" },
  { to: "/admin/shopping-integrations", label: "Shopping Integrations", icon: Boxes, section: "Growth" },
  { to: "/admin/service-integrations", label: "Service Integrations", icon: Plane, section: "Growth" },
  { to: "/admin/maps-keys", label: "Google Maps Keys", icon: Map, section: "Growth" },

  { to: "/admin/providers", label: "Service Providers", icon: Server, section: "Platform" },
  { to: "/admin/travel-locations", label: "Travel Locations", icon: MapPin, section: "Platform" },
  { to: "/admin/integrations", label: "Integrations", icon: Handshake, section: "Platform" },
  { to: "/admin/comm-routing", label: "Communication Routing", icon: Radio, section: "Platform" },
  { to: "/admin/message-guide", label: "Message Content Guide", icon: ScrollText, section: "Platform" },

  { to: "/admin/support", label: "Support", icon: LifeBuoy, section: "Support" },
  { to: "/admin/notifications", label: "Communication Center", icon: Bell, section: "Support" },
  { to: "/admin/email-health", label: "Email Health", icon: MailWarning, section: "Support" },
  { to: "/admin/email-manager", label: "Email Manager", icon: Mail, section: "Support" },

  { to: "/admin/company", label: "Company Info", icon: Building2, section: "Settings" },
  { to: "/admin/legal", label: "Legal Pages", icon: FileText, section: "Settings" },
  { to: "/admin/inquiries", label: "Support Center — Inquiries", icon: LifeBuoy, section: "Support" },
  { to: "/admin/earnings", label: "Earnings Dashboard", icon: BarChart3, section: "Overview" },
  { to: "/admin/product-guard", label: "Product Guard", icon: ShieldCheck, section: "Settings" },
  { to: "/admin/broadcast", label: "Broadcast Tool", icon: Bell, section: "Support" },
  { to: "/admin/audit", label: "Audit Logs", icon: ScrollText, section: "Settings" },
];

// Sections open by default; the rest start collapsed to keep the long admin nav tidy.
export const ADMIN_DEFAULT_OPEN_SECTIONS = ["Overview", "Catalog", "Orders & Fulfilment"];

export const ADMIN_BOTTOM = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/products", label: "Products", icon: ShoppingBag },
  { to: "/admin/orders", label: "Orders", icon: Package },
  { to: "/admin/finance", label: "Finance", icon: Receipt },
  { to: "/admin/support", label: "Support", icon: LifeBuoy },
];
